<template>
<div>
  <div class="condition-box mr-b25">
    <span class="mr-r4">기간선택</span>
    <el-date-picker style="width:225px;" v-model="histDateRange" type="daterange"
     :range-separator="defaultDateRangeOptions.rangeSeparator" :start-placeholder="defaultDateRangeOptions.startPlaceholder"
     :end-placeholder="defaultDateRangeOptions.endPlaceholder" :default-time="defaultDateRangeOptions.defaultTime"
      :picker-options="defaultDateRangeOptions.pickerOptions" :clearable="false" />
    <div class="fl-r">
        <ul class="diff-legend-box">
          <li><span class="item added"></span>추가</li>
          <li><span class="item modified"></span>변경</li>
          <li><span class="item deleted"></span>삭제</li>
        </ul>
        <el-radio-group class="ordinary cmp-margin-left" v-model="diffFlag">
            <el-radio-button :label="true">변경내역만 보기</el-radio-button>
            <el-radio-button :label="false">전체 보기</el-radio-button>
          </el-radio-group>
      </div>
  </div>
  <div class="title-bar" type="flex">
    <div class="vertical-center-box" style="width:calc(50% - 15px);">
      <span class="title-h4 dot-title mr-r10">기준 컨피그</span>
      <el-select style="width:144px;" v-model="baseHistSeq" placeholder="변경 이력 선택" @change="compareHist">
        <el-option v-for="changeInfo in checkItemHistList" :key="changeInfo.seq" :label="convertCheckDatetime(changeInfo.checkDatetime)" :value="changeInfo.seq"></el-option>
      </el-select>
      <em v-if="isEqualHist" class="mr-l10">동일한 이력입니다.</em>
    </div>
    <div class="mr-l15" style="width:50%;">
      <el-row type="flex" justify="space-between">
        <div class="vertical-center-box">
          <span class="title-h4 dot-title mr-r10">비교대상 컨피그</span>
          <el-select style="width:144px;" v-model="compareHistSeq" placeholder="변경 이력 선택" @change="compareHist">
            <el-option v-for="changeInfo in checkItemHistList" :key="changeInfo.seq" :label="convertCheckDatetime(changeInfo.checkDatetime)" :value="changeInfo.seq"></el-option>
          </el-select>
        </div>
      </el-row>
    </div>
  </div>
  <el-row type="flex">
    <div style="width:100%;" v-html="showCompareText"></div>
  </el-row>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import msgUtil from '@/utils/message';
import { isTrue } from '@/utils/boolean';
import { faultCheckItemDefine } from '@/constants/netdevice';
import { defaultDateRangeOptions, getDateToString } from '@/utils/date';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';

export default {
  name: 'WConfigInfoNode',
  props: {
    activeTab: {
      type: String,
    },
    nodeParams: {
      type: Object,
    },
  },
  data() {
    return {
      popupVisible: false,
      defaultDateRangeOptions,
      isLoading: false,
      histDateRange: [],
      params: {
        itemId: faultCheckItemDefine.CONFIG,
        requestKey: faultCheckItemDefine.CONFIG.toLowerCase(),
      },
      baseHistSeq: null,
      compareHistSeq: null,
      checkItemHistList: [],
      compareHistData: null,
      diffFlag: true,
      showCompareText: '',
      isEqualHist: false,
    };
  },
  watch: {
    activeTab: {
      handler() {
        this.setConfigParams();
      },
    },
    nodeParams: {
      handler() {
        this.setConfigParams();
      },
      immediate: true,
    },
    histDateRange: {
      handler() {
        this.params.startDatetime = this.histDateRange[0].getTime();
        this.params.endDatetime = this.histDateRange[1].getTime();
        this.loadCheckItemHist();
      },
    },
    diffFlag: {
      handler() {
        this.setShowCompareText();
      },
    },
  },
  methods: {
    setConfigParams() {
      const configParams = {
        objId: this.nodeParams.objId,
      };
      if (this.activeTab === this.$options.name) {
        netdeviceInfoAPI.getNetdeviceConfigInfoList(configParams).then((response) => {
          if (response.data.success) {
            const rsltData = response.data.data;
            const lastIdx = rsltData.length - 1;
            const checkDatetime = !(lastIdx < 0) && !isNil(rsltData[lastIdx]) ? new Date(rsltData[lastIdx].recentCheckDatetime) : new Date();
            const endDatetime = moment(checkDatetime).endOf('day');
            const startDatetime = endDatetime.clone().subtract(1, 'months').startOf('day');
            const histDateRange = [startDatetime.toDate(), endDatetime.toDate()];
            this.histDateRange = histDateRange;
          }
        });
      }
    },
    /**
     * 상단 날짜 범위 조정 시 데이터 조회 (histSeq, checkDatetime)
     * @author kimjy
     */
    loadCheckItemHist() {
      // this.params.objId = this.popupHistInfo.objId;
      this.params.objId = this.nodeParams.objId;
      netdeviceInfoAPI.getNetdeviceCheckHist(this.params).then((response) => {
        if (response.data.success) {
          this.setCheckItemHist(response.data.data);
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '변경 이력', false));
          this.checkItemHistList = [];
          this.clearCompareHistData();
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '변경 이력', false));
        this.checkItemHistList = [];
        this.clearCompareHistData();
      }).finally(() => {
        this.isLoading = false;
      });
    },
    /**
     * 변경 이력 목록을 로드한다.
     * @author kimjy
     * @param  {Object} response
     */
    setCheckItemHist(data) {
      if (!isEmpty(data)) {
        this.checkItemHistList = data;
        this.compareHistSeq = this.checkItemHistList[0].seq; // Right : 최근 값
        if (data.length > 1) {
          this.baseHistSeq = this.checkItemHistList[1].seq; // Left: 이전 값
        } else {
          this.baseHistSeq = this.checkItemHistList[0].seq;
        }
        this.compareHist();
      } else {
        this.clearCompareHistData();
      }
    },
    /**
     * 두 개의 변경 이력 내용을 비교한다.
     * @author kimjy
     */
    compareHist() {
      const params = {
        objId: this.nodeParams.objId,
        itemId: this.params.itemId,
        requestKey: this.params.requestKey,
        baseHistSeq: this.baseHistSeq,
        compareHistSeq: this.compareHistSeq,
      };
      this.isEqualHist = this.baseHistSeq === this.compareHistSeq;
      this.isLoading = true;
      netdeviceInfoAPI.getNetdeviceComparedData(params).then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          if (!isEmpty(data)) {
            this.setComparedData(data);
          } else {
            this.clearCompareHistData();
          }
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '변경 이력', false));
          this.clearCompareHistData();
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '변경 이력', false));
        this.clearCompareHistData();
      }).finally(() => {
        this.isLoading = false;
      });
    },
    convertCheckDatetime(value) {
      return getDateToString(value);
    },
    /**
     * [공통] 변경 이력 비교 정보를 설정한다.
     * @author Ju
     * @param  {[type]} data [description]
     */
    setComparedData(data) {
      this.compareHistData = data;
      this.diffFlag = isTrue(data.compareData.diffFlag);
      this.setShowCompareText();
    },
    /**
     * 비교 데이터 중 보여줄 데이터 (변경된 내용 / 전체)를 설정한다.
     * @author Ju
     */
    setShowCompareText() {
      this.showCompareText = this.diffFlag ? this.compareHistData.compareData.diff : this.compareHistData.compareData.compare;
    },
    /**
     * 비교 데이터를 초기화한다.
     * @author Ju
     * @return {[type]} [description]
     */
    clearCompareHistData() {
      this.checkItemHistList = [];
      this.baseHistSeq = null;
      this.compareHistSeq = null;
      this.showCompareText = '';
      this.compareHistData = {};
    },
  },
};
</script>

<style module>
.change-box-left {
  width: calc(50% - 4px);
  margin-right: 4px;
}

.change-box-right {
  width: calc(50% - 4px);
  margin-left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/config/node/netdevice/config/index.vue